import '~/js/pages/individuals';
import Tabs from '~/js/modules/tabs';

window.addEventListener(`DOMContentLoaded`, () => {
  const mainTabsControls = document.querySelectorAll(".js-tabs-controls-main")
  const mainTabsContainer = document.querySelectorAll(".js-tabs-container-main")
  if (mainTabsControls.length && mainTabsContainer.length) {
    mainTabsControls.forEach((control, i) => new Tabs(control, mainTabsContainer[i], '-main'))
  }
})